import React, { useContext, useState } from "react";
import { useFormContext } from "../createworkflow/FormContext";
import MenuContext from "./MenuContext";
import { displayMessage } from "../../Utils/helper";
import { ErrorBoundary } from "../common/ErrorBoundary";
import { SubmitWorkflowPayloadPrep } from "./helper"
import { sumbitWorkflow } from "../../services/ApiWorkflow"
import { useNavigate } from 'react-router-dom';
import Loader from "../common/Loader";

export default function Stage7() {
  const { setActiveTab } = useContext(MenuContext);
  const { formData, updateFormData } = useFormContext();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false)

  const EditButtonClickHandler = () => {
    setActiveTab("Stage6");
  };
  console.log("formData", formData);

  const SubmitButtonClickHandler = async () => {

    if (formData.stage1?.workflow_name === "" || formData.stage1?.workflow_name === undefined) {
      displayMessage("danger", "Workflow name is mandatory");
      return;
    }
    if (formData.stage1?.data_upload_id === null || formData.stage1?.data_upload_id === undefined) {
      displayMessage("danger", "Please choose upload type for file upload");
      return;
    }
    if (formData.stage2?.data_frequency === null || formData.stage2?.data_frequency === undefined) {
      displayMessage("danger", "Data Frequency is mandatory");
      return;
    }
    if (formData.stage2?.forecast_period === null || formData.stage2?.forecast_period === undefined) {
      displayMessage("danger", "Forecast Period is mandatory");
      return;
    }
    if (formData.stage3 === null) {
      displayMessage("danger", "Please select at least one product and one geography");
      return;
    }
    if (formData.stage3?.products === undefined || formData.stage3?.products?.length === 0) {
      displayMessage("danger", "Please select at least one product");
      return;
    }
    if (formData.stage3?.geography === undefined || formData.stage3?.geography?.length === 0) {
      displayMessage("danger", "Please select at least one geography");
      return;
    }
    if (formData.stage4?.combinations?.length === 0) {
      displayMessage("danger", "Please select at least one combination");
      return;
    }
    if (formData.stage6?.models.length === 0) {
      displayMessage("danger", "Please select at least one model");
      return;
    }

    setIsLoading(true)
    let payload = SubmitWorkflowPayloadPrep(formData);
    let result = await sumbitWorkflow(payload);
    if (result === null) {
      displayMessage("danger", "Error occured while submitting workflow");
    } else {
      sessionStorage.clear('formData');
      //console.log(result);
      navigate('/ManageWorkflow');
      displayMessage("success", "Workflow submitted successfully");

    }
    setIsLoading(false)
  };

  return (
    <ErrorBoundary>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div class="createworkflowtabcontents">
            <div id="stage7">
              <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="table-responsive">
                  <table class="table reviewtable table-bordered">
                    <tbody>
                      <tr>
                        <td colSpan={2} >
                          <center>Initialize Workflow</center>
                        </td>
                      </tr>
                      <Row title={"Workflow Name"}>{formData.stage1?.workflow_name || ""}</Row>
                      <Row title={"Workflow Description"}>{formData.stage1?.workflow_description || ""}</Row>
                      <Row title={"File Upload Type"}>{formData.stage1?.file_upload_option || ""}</Row>
                      {formData.stage1?.file_upload_option?.toLowerCase() === "new" && <>
                        <Row title={"Forecast File Uploaded"}>
                          {formData.stage1?.file_upload_status?.[0]
                            ? (formData.stage1.file_upload_status[0].success ? "YES" : "NO")
                            : "NO"}
                        </Row>
                        <Row title={"EOQ File Uploaded"}>
                          {formData.stage1?.file_upload_status?.[1]
                            ? (formData.stage1.file_upload_status[1].success ? "YES" : "NO")
                            : "NO"}
                        </Row>
                        <Row title={"Inventory File Uploaded"}>
                          {formData.stage1?.file_upload_status?.[2]
                            ? (formData.stage1.file_upload_status[2].success ? "YES" : "NO")
                            : "NO"}
                        </Row>
                        <Row title={"Safety Stock File Uploaded"}>
                          {formData.stage1?.file_upload_status?.[3]
                            ? (formData.stage1.file_upload_status[3].success ? "YES" : "NO")
                            : "NO"}
                        </Row>
                      </>}
                      {/* <Row title={"EOQ File Uploaded"}>{formData.stage1?.file_upload_status?.[1].success ? "YES" : "NO"}</Row>
                      <Row title={"Inventory File Uploaded"}>{formData.stage1?.file_upload_status?.[2].success ? "YES" : "NO"}</Row>
                      <Row title={"Safety Stock File Uploaded"}>{formData.stage1?.file_upload_status?.[3].success ? "YES" : "NO"}</Row> */}

                      <tr>
                        <td colSpan={2} >
                          <center>Temporal Settings</center>
                        </td>
                      </tr>
                      <Row title={"Data Frequency"}>{formData.stage2?.data_frequency || ""}</Row>
                      <Row title={"Train Period (in %)"}>{formData.stage2?.train_percentage || ""}</Row>
                      <Row title={"Test Period (in %)"}>{formData.stage2?.test_percentage || ""}</Row>
                      <Row title={"Forecast frequency"}>{formData.stage2?.forecast_frequency || ""}</Row>
                      <Row title={"Forecast Period"}>{formData.stage2?.forecast_period || ""}</Row>
                      <tr>
                        <td colSpan={2} >
                          <center>Data Selection</center>
                        </td>
                      </tr>
                      <Row title={"Selected Number of SKUs"}>{formData.stage3?.products?.length || ""}</Row>
                      <Row title={"Selected Number of Locations"}>{formData.stage3?.geography?.length || ""}</Row>
                      <tr>
                        <td colSpan={2} >
                          <center>Data Availability</center>
                        </td>
                      </tr>
                      <Row title={"Selected Number of Combinations"}>{formData.stage4?.combinations?.length}</Row>
                      <tr>
                        <td colSpan={2} >
                          <center>Model Selection</center>
                        </td>
                      </tr>
                      <tr>
                        <td>Models</td>
                        <td>
                          {formData.stage6?.models.join(" , ") || ""}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {isLoading &&
                <center><Loader size={'large'} /></center>
              }
              {!isLoading && <div className="col-md-12 col-sm-12 col-xs-12 padding">
                <div class="col-md-6 col-sm-6 col-xs-6">
                  <div class="form-group1">
                    <div class="editbtn">
                      <a onClick={EditButtonClickHandler} className="cursor-pointer">
                        {" "}
                        <iconify-icon icon="iconamoon:arrow-left-2-duotone"></iconify-icon>
                        EDIT
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-xs-6">
                  <div class="form-group1">
                    <div class="subbtn">
                      <a onClick={SubmitButtonClickHandler} className="cursor-pointer">
                        Submit{" "}
                        <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon>
                      </a>
                    </div>
                  </div>
                </div>
              </div>}
            </div>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
}
function Row({ title, children }) {
  return (
    <tr>
      <td>{title}</td>
      <td>{children}</td>
    </tr>
  )
}

